import React from "react";

const buttonResetStyle = {
  background: "none",
  border: "none",
  padding: 0,
  display: "inline-flex",
  cursor: "pointer",
};

function IconVerticalEllipses({ showBoardMenu }) {
  return (
    <button
      type="button"
      aria-label="Board options"
      onClick={showBoardMenu}
      style={buttonResetStyle}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="20" aria-hidden="true">
        <g fill="#828FA3" fillRule="evenodd">
          <circle cx="2.308" cy="2.308" r="2.308"></circle>
          <circle cx="2.308" cy="10" r="2.308"></circle>
          <circle cx="2.308" cy="17.692" r="2.308"></circle>
        </g>
      </svg>
    </button>
  );
}

export default IconVerticalEllipses;
